import classNames from "classnames";
import React from "react";

interface Props {
  count: number
  type: "unset" | "approved" | "declined"
}

const ChecklistStatus = ({ count, type }: Props) => {
  const className = classNames("s1_tag small", {
    "gray-bg": type === "unset",
    "green-bg": type === "approved",
    "red-bg": type === "declined"
  });

  return <div className={className}>
    <div className="flex">
      <div>
        {type === "unset" && <i style={{ fontSize: 8 }} className="icon-hourglass" />}
        {type === "approved" && <i style={{ fontSize: 8 }} className="icon-check" />}
        {type === "declined" && <i style={{ fontSize: 8 }} className="icon-x" />}
      </div>
      <div className="s1_smaller" style={{ width: 12, textAlign: "right" }}>
        {count}
      </div>
    </div>
  </div>;
};

export default ChecklistStatus;